<template>
  <div :id="id" class="modal fade modalDelete customModal" tabindex="-1" :aria-labelledby="id" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 mt-sm-3">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true"><img src="../../public/src/images/icon-modal-close.svg" alt="icon-modal-close" /></span>
                </button>
              </div>
              <div class="col-12 text-center">
                <h3 class="modal-title mt-2">Excel Dosyası Olarak İndir</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div v-for="(field, keyIndex) in excelFields" :key="'key' + keyIndex" class="col-sm-4">
                    <base-check-box :text="field.text" :input-model="isASelectedExcelField(field)" @change.native="setExcelList(field, $event)" />
                  </div>
                </div>
              </div>
              <div class="col-12 mt-4">
                <base-button :btn-text="'Excel İndir'" :btn-disabled="btnDisabled" :btn-size="'btn-sm'" class="mt-auto" @click.native="emitDownloadExcel()" />
                <download-excel ref="downloadExcel" class="d-none" :data="data" :fields="excelFieldModel" :name="fileName" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCheckBox from "./element/form/BaseCheckbox.vue";
import BaseButton from "./element/buttons/BaseButton.vue";

import JsonExcel from "vue-json-excel";
import Vue from "vue";

Vue.component("DownloadExcel", JsonExcel);
export default {
  name: "ExcelModal",
  components: { BaseButton, BaseCheckBox },
  props: {
    id: {
      type: String,
      default: "excelModal",
    },
    excelFields: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    fileName: {
      type: String,
      default: "excelFile",
    },
  },
  data() {
    return {
      selectedExcelFields: [],
      excelFieldModel: {},
      btnDisabled: true,
    };
  },
  created() {
    this.excelFields.forEach((field) => {
      this.setExcelList(field);
    });
  },
  methods: {
    emitDownloadExcel() {
      this.excelFieldModel = {};
      let res = this.selectedExcelFields.sort((a, b) => a.id - b.id);
      res.forEach((field) => {
        let newField = {};
        if (field.isHasCallBack) {
          let key = field.text;
          newField = {
            [key]: {
              field: field.value,
              callback: field.callback,
            },
          };
        } else {
          newField = { [field.text]: field.value };
        }
        this.excelFieldModel = { ...this.excelFieldModel, ...newField };
      });
      this.$nextTick(() => {
        this.$emit("emitDownloadExcel", this.excelFieldModel);
      });
    },
    setExcelList(field) {
      let findIndex = this.selectedExcelFields.findIndex((item) => item.id === field.id);
      if (findIndex > -1) {
        this.selectedExcelFields.splice(findIndex, 1);
        if (this.selectedExcelFields.length === 0) {
          this.btnDisabled = true;
        }
      } else {
        this.selectedExcelFields.push(field);
        this.btnDisabled = false;
      }
    },
    isASelectedExcelField(field) {
      let findSelectedExcelField = this.selectedExcelFields.find((item) => item.id === field.id);
      if (findSelectedExcelField) {
        return findSelectedExcelField;
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.close {
  margin: 5px;
  padding: 5px;
}
</style>
